import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import BackgroundBox from '../../../components/custom_components/BackgroundBox'
import { PerEmpty } from '../../../components/custom_components/Empty'
import { LoadingAndErrors } from '../../../components/custom_components/LoadingAndErrors'
import { useTalentsSeasonYears } from '../../../graphql/talents-season/useTalentsSeasonYears'
import { Country, TalentsSeasonStatus, TalentsSeasonYearDto } from '../../../types'
import { RankingToggle } from './RankingToggle'
import { TalentsSeasonContent } from './TalentsSeasonContent'

interface CultivatingTalentsWithRankingAndTagAssignmentProps {
  companyId: string
  country: Country
  isHRSettings: boolean
  isAllCompaniesSettings: boolean
  isYourCompanyView: boolean
}

export const CultivatingTalentsWithRankingAndTagAssignment: FC<CultivatingTalentsWithRankingAndTagAssignmentProps> = ({
  companyId,
  country,
  isAllCompaniesSettings,
  isYourCompanyView,
  isHRSettings,
}) => {
  const { t } = useTranslation()
  const { data, error, loading } = useTalentsSeasonYears(companyId, country)

  if (loading || error || !data || !data.findTalentsSeasonsYears) {
    return <LoadingAndErrors isLoading={loading} hasNoData={!data || !data.findTalentsSeasonsYears} error={error} showSpinner />
  }

  const talentsSeasonYears: TalentsSeasonYearDto[] = data.findTalentsSeasonsYears

  const isDisableRankingNotPossible = talentsSeasonYears.find((dto) => {
    return ![TalentsSeasonStatus.Ready].includes(dto.talentsSeasonStatus)
  })

  return (
    <>
      {isHRSettings && !isDisableRankingNotPossible && <RankingToggle isRankingEnabled companyId={companyId} country={country} />}
      {talentsSeasonYears.length > 0 ? (
        <TalentsSeasonContent
          talentsSeasonYears={talentsSeasonYears}
          isHRSettings={isHRSettings}
          isAllCompaniesSettings={isAllCompaniesSettings}
          isYourCompanyView={isYourCompanyView}
        />
      ) : (
        <BackgroundBox color="white75" r>
          <PerEmpty iconSize="m" icon="empty_stroke" heading={t('companySettingsView.rankingTab.seasonNotOpenYet')} />
        </BackgroundBox>
      )}
    </>
  )
}
